export class SourceAccountMetricsConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountMetricsConfig.attributeTypeMap;
    }
    constructor() {
    }
}
